module.exports = __webpack_public_path__ + "static/media/1.eac5bd38.png";